'use strict'
//
var validateLicense = require('./validateLicense')
var createLicense = require('./createLicense')
//
module.exports = { validateLicense, createLicense }
